import React, { lazy } from 'react';
// /client/safety-home/main
const HomeStdSafetyMain = lazy(() => import('@/pages/client/StdSafety/Main'));
const SafetyTaskFormTest = lazy(() => import("@/pages/client/StdSafety/SafetyTaskFormTest"));
const FormTaskList = lazy(() => import('@/pages/client/StdSafety/FormTaskList'));
const AIReport = lazy(() => import('@/pages/client/StdSafety/FormReportList/AIReport'));
const FormReportList = lazy(() => import('@/pages/client/StdSafety/FormReportList'));
const UserFormIframe = lazy(() => import("@/pages/client/StdSafety/SafetyTaskFormTest/userFormIframe"));
const Payment = lazy(() => import("@/pages/client/StdSafety/Payment"));
const Welcome = lazy(() => import("@/pages/client/StdSafety/Welcome"));

const stdSafetyRoutes = [
  // { path: '/client/hello', element: <Hello />, needInterceptor: true },
  { path: '/client/safety-home/main', component: <HomeStdSafetyMain />, needInterceptor: true },
  { path: '/client/safety-welcome', component: <Welcome />, needInterceptor: true },
  { path: '/client/safety-task-form-test', component: <SafetyTaskFormTest />, needInterceptor: true },
  { path: '/client/safety-form-task-list', component: <FormTaskList />, needInterceptor: true },
  { path: '/client/safety-ai-report', component: <AIReport />, needInterceptor: true },
  { path: '/client/safety-test-user-form', component: <UserFormIframe />, needInterceptor: true },
  { path: '/client/safety-report-list', component: <FormReportList />, needInterceptor: true },
  { path: '/client/safety-payment', component: <Payment />, needInterceptor: true },
];
export default stdSafetyRoutes;